import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/client";
import { BatchHttpLink } from "@apollo/client/link/batch-http";
import { setContext } from "@apollo/client/link/context";
import { fetchAuthSession } from "aws-amplify/auth";
import { createEnhancedApolloErrorLink } from "./shared/apollo-error-link";
import { createBreakingChangesFetch } from "shared/src/utils/breaking-changes";

const graphQLUrl = import.meta.env.VITE_GRAPHQL_URL;

export const buildPublicUrl = (baseUrl: string): string =>
  baseUrl.replace(/\/+$/, "") + "-public";

const graphQLPublicUrl = buildPublicUrl(graphQLUrl);

const breakingChangesFetch = createBreakingChangesFetch(fetch);

const PUBLIC_OPERATIONS = [
  "UpdateAppealStatusWithToken",
  "CreateAppealStaging",
];

const authenticatedHttpLink = new BatchHttpLink({
  uri: graphQLUrl,
  batchMax: 5,
  batchInterval: 20,
  fetch: breakingChangesFetch,
});
const publicHttpLink = new BatchHttpLink({
  uri: graphQLPublicUrl,
  batchMax: 5,
  batchInterval: 20,
  fetch: breakingChangesFetch,
});

const authLink = setContext(async (_, { headers }) => {
  const session = await fetchAuthSession();

  const token = session?.tokens?.accessToken.toString();

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const isPublicOperation = (operationName: string | undefined): boolean =>
  PUBLIC_OPERATIONS.includes(operationName ?? "");

const routingLink = ApolloLink.split(
  (operation) => isPublicOperation(operation.operationName),
  publicHttpLink,
  authLink.concat(authenticatedHttpLink),
);

const errorLink = createEnhancedApolloErrorLink();

const graphQLClient = new ApolloClient({
  cache: new InMemoryCache({}),
  link: errorLink.concat(routingLink),
  devtools: {
    enabled: false,
  },
});

export default graphQLClient;
